// extracted by mini-css-extract-plugin
export var closeButton = "_ht-2";
export var closeButtonIcon = "_ht-3";
export var lightboxContent = "_ht-1";
export var lightboxOverlay = "_ht-0";